import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "formik";
import { Grid, Select, MenuItem } from "@material-ui/core";
import { TextInput, AutoCompleteInput, DatePicker } from "components/Global/FastFormikMaterial";
import styled from "styled-components";
import moment from "moment";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyleDatePicker = styled(DatePicker)`
  && {
    width:100%;
  }
`;

const SideLabelWithDropdownInput = ({ label, dropdownLabel, fieldName, dropdownFieldName, placeholder, formik, isDisabled, hasBorder,
  shouldHideForQuote, options, shouldIndent, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const val = _.get(formik.values, fieldName);
  const dropdownValue = _.get(formik.values, dropdownFieldName);

  return (
    <LateralField shouldIndent={shouldIndent} label={label} hasBorder={hasBorder}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={7}>
            <ViewOnlyDiv>{val ? moment(val).format("MM/DD/YYYY") : "--"}</ViewOnlyDiv>
          </Grid>
          <Grid item xs={5}>
            <ViewOnlyDiv placeholder="">{getDropdownLabelOfValue(options, dropdownValue)}</ViewOnlyDiv>
          </Grid>
        </Grid>)}
      {!isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={7}>
            <StyleDatePicker
              fieldName={fieldName}
              placeholder={placeholder}
              {...otherProps}
            />
          </Grid>
          <Grid item xs={5} style={{ whiteSpace: "nowrap" }}>
            <span style={{ fontWeight: "bold" }}>{`${dropdownLabel} `}</span>
            <Select
              style={{ marginLeft: "10px" }}
              name={dropdownFieldName}
              value={dropdownValue}
              onChange={event => {
                formik.setFieldValue(dropdownFieldName, event.target.value);
              }}
            >
              {options &&
                      options.map(item => (
                        <MenuItem key={item.label} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
            </Select>
          </Grid>
        </Grid>)}
    </LateralField>
  );
};

const getDropdownLabelOfValue = (options, dropdownValue) => {
  if (!options || !dropdownValue) {
    return null;
  }
  const item = options.filter(x => x.value == dropdownValue)[0];
  if (!item) {
    return null;
  }

  return item.label;
};
export default connect(SideLabelWithDropdownInput);
